export default function() {
    return {
      waitlist: [],
      isWaitlistDataLoaded: false,
      waitlistRegistrationDialog: false,
      waitlistDropInCoachingSlot:false,
      waitlistDropInType: false
    }
}
